"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTROLS_OPTIONS = exports.STYLE_MAP = exports.CONTROLS = exports.EDITOR_CHANGE_TYPES = exports.UNDO = exports.SPLIT_BLOCK = exports.SPELLCHECK_CHANGE = exports.REMOVE_RANGE = exports.REDO = exports.INSERT_FRAGMENT = exports.INSERT_CHARACTERS = exports.DELETE_CHARACTER = exports.MOVE_BLOCK = exports.CHANGE_INLINE_STYLE = exports.CHANGE_BLOCK_TYPE = exports.CHANGE_BLOCK_DATA = exports.BACKSPACE_CHARACTER = exports.APPLY_ENTITY = exports.ADJUST_DEPTH = exports.FORMAT_TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("../components");

var _Entities = require("../components/RichTextEditor/Entities");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FORMAT_TYPES = ['html', 'markdown'];
exports.FORMAT_TYPES = FORMAT_TYPES;
var ADJUST_DEPTH = 'adjust-depth';
exports.ADJUST_DEPTH = ADJUST_DEPTH;
var APPLY_ENTITY = 'apply-entity';
exports.APPLY_ENTITY = APPLY_ENTITY;
var BACKSPACE_CHARACTER = 'backspace-character';
exports.BACKSPACE_CHARACTER = BACKSPACE_CHARACTER;
var CHANGE_BLOCK_DATA = 'change-block-data';
exports.CHANGE_BLOCK_DATA = CHANGE_BLOCK_DATA;
var CHANGE_BLOCK_TYPE = 'change-block-type';
exports.CHANGE_BLOCK_TYPE = CHANGE_BLOCK_TYPE;
var CHANGE_INLINE_STYLE = 'change-inline-style';
exports.CHANGE_INLINE_STYLE = CHANGE_INLINE_STYLE;
var MOVE_BLOCK = 'move-block';
exports.MOVE_BLOCK = MOVE_BLOCK;
var DELETE_CHARACTER = 'delete-character';
exports.DELETE_CHARACTER = DELETE_CHARACTER;
var INSERT_CHARACTERS = 'insert-characters';
exports.INSERT_CHARACTERS = INSERT_CHARACTERS;
var INSERT_FRAGMENT = 'insert-fragment';
exports.INSERT_FRAGMENT = INSERT_FRAGMENT;
var REDO = 'redo';
exports.REDO = REDO;
var REMOVE_RANGE = 'remove-range';
exports.REMOVE_RANGE = REMOVE_RANGE;
var SPELLCHECK_CHANGE = 'spellcheck-change';
exports.SPELLCHECK_CHANGE = SPELLCHECK_CHANGE;
var SPLIT_BLOCK = 'split-block';
exports.SPLIT_BLOCK = SPLIT_BLOCK;
var UNDO = 'undo';
exports.UNDO = UNDO;
var EDITOR_CHANGE_TYPES = [ADJUST_DEPTH, APPLY_ENTITY, BACKSPACE_CHARACTER, CHANGE_BLOCK_DATA, CHANGE_BLOCK_TYPE, CHANGE_INLINE_STYLE, MOVE_BLOCK, DELETE_CHARACTER, INSERT_CHARACTERS, INSERT_FRAGMENT, REDO, REMOVE_RANGE, SPELLCHECK_CHANGE, SPLIT_BLOCK, UNDO];
exports.EDITOR_CHANGE_TYPES = EDITOR_CHANGE_TYPES;
var CONTROLS = [{
  label: 'Normal Text',
  icon: null,
  value: 'unstyled',
  data: {
    type: 'BLOCK_STYLE'
  }
}, // {
//   label: 'Paragraph',
//   icon: null,
//   value: 'paragraph',
//   data: { type: 'BLOCK_STYLE' },
// },
// {
//   label: 'Atomic',
//   icon: null,
//   value: 'atomic',
//   data: { type: 'BLOCK_STYLE' },
// },
{
  label: 'Heading 1',
  icon: _react["default"].createElement(_components.Icon.Heading1, null),
  value: 'header-one',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Heading 2',
  icon: _react["default"].createElement(_components.Icon.Heading2, null),
  value: 'header-two',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Heading 3',
  icon: _react["default"].createElement(_components.Icon.Heading3, null),
  value: 'header-three',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Heading 4',
  icon: _react["default"].createElement(_components.Icon.Heading4, null),
  value: 'header-four',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Heading 5',
  icon: _react["default"].createElement(_components.Icon.Heading5, null),
  value: 'header-five',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Heading 6',
  icon: _react["default"].createElement(_components.Icon.Heading6, null),
  value: 'header-six',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Align Left',
  icon: _react["default"].createElement(_components.Icon.AlignLeft, null),
  value: 'TEXT_ALIGN_LEFT',
  data: {
    type: 'BLOCK_STYLE',
    metaData: {
      textAlign: 'left'
    }
  }
}, {
  label: 'Align Center',
  icon: _react["default"].createElement(_components.Icon.AlignMiddle, null),
  value: 'TEXT_ALIGN_CENTER',
  data: {
    type: 'BLOCK_STYLE',
    metaData: {
      textAlign: 'center'
    }
  }
}, {
  label: 'Align Right',
  icon: _react["default"].createElement(_components.Icon.AlignRight, null),
  value: 'TEXT_ALIGN_RIGHT',
  data: {
    type: 'BLOCK_STYLE',
    metaData: {
      textAlign: 'right'
    }
  }
}, {
  label: 'Align Justify',
  icon: _react["default"].createElement(_components.Icon.Justify, null),
  value: 'TEXT_ALIGN_JUSTIFY',
  data: {
    type: 'BLOCK_STYLE',
    metaData: {
      textAlign: 'justify'
    }
  }
}, {
  label: 'Bold',
  icon: _react["default"].createElement(_components.Icon.Bold, null),
  value: 'BOLD',
  data: {
    type: 'INLINE_STYLE'
  }
}, {
  label: 'Underline',
  icon: _react["default"].createElement(_components.Icon.Underline, null),
  value: 'UNDERLINE',
  data: {
    type: 'INLINE_STYLE'
  }
}, {
  label: 'Italic',
  icon: _react["default"].createElement(_components.Icon.Italic, null),
  value: 'ITALIC',
  data: {
    type: 'INLINE_STYLE'
  }
}, {
  label: 'Monospace',
  icon: _react["default"].createElement(_components.Icon.Monospace, null),
  value: 'CODE',
  data: {
    type: 'INLINE_STYLE'
  }
}, {
  label: 'Link',
  icon: _react["default"].createElement(_components.Icon.Link, null),
  component: _Entities.LinkEntity,
  data: {
    type: 'ENTITY_STYLE'
  }
}, {
  label: 'UL',
  icon: _react["default"].createElement(_components.Icon.BulletPoint, null),
  value: 'unordered-list-item',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'OL',
  icon: _react["default"].createElement(_components.Icon.OrderedList, null),
  value: 'ordered-list-item',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Blockquote',
  icon: _react["default"].createElement(_components.Icon.Blockquote, null),
  value: 'blockquote',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Code',
  icon: _react["default"].createElement(_components.Icon.Codeblock, null),
  value: 'code-block',
  data: {
    type: 'BLOCK_STYLE'
  }
}, {
  label: 'Strikethrough',
  icon: _react["default"].createElement(_components.Icon.Strikethrough, null),
  value: 'STRIKETHROUGH',
  data: {
    type: 'INLINE_STYLE'
  }
}];
exports.CONTROLS = CONTROLS;
var STYLE_MAP = {
  CODE: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  TEXT_ALIGN_LEFT: {
    textAlign: 'left'
  },
  TEXT_ALIGN_RIGHT: {
    textAlign: 'right'
  },
  TEXT_ALIGN_CENTER: {
    textAlign: 'center'
  },
  TEXT_ALIGN_JUSTIFY: {
    textAlign: 'justify'
  }
};
exports.STYLE_MAP = STYLE_MAP;
var CONTROLS_OPTIONS = CONTROLS.map(function (_ref) {
  var label = _ref.label;
  return label.toLowerCase();
});
exports.CONTROLS_OPTIONS = CONTROLS_OPTIONS;